import {createContext} from '@lit-labs/context';
import type {AudienceBuilder} from '#lit/builders/audience_builder/builder.js';

export const AudienceBuilderContext = createContext<AudienceBuilder>(
  'audience-builder-context'
);
